import { ADD_NOTES } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_NOTES.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_NOTES.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADD_NOTES.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
